import { useState, useEffect } from 'preact/hooks';
import { sendRequest } from '../../../../tools';

export const useFetchAccounts = (getAccountsUrl, accountId) => {
  const [accounts, setAccounts] = useState([]);
  const [account, setAccount] = useState(null);
  const [selectedContractIds, setSelectedContractIds] = useState([]);
  const [contractIds, setContractIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await sendRequest(getAccountsUrl, { showLoader: false });
        if (response.status === 200) {
          const allAccounts = response.data.items;
          allAccounts.push({ id: '0', address: 'Нет нужного адреса' });
          setAccounts(allAccounts);
          console.log('accounts', accounts);

          const selectedContractdIds = [];
          const contractdIds = [];

          response.data.items.forEach(accountItem => {
            if (accountItem.id === accountId) {
              setAccount(accountItem);

              const { contracts } = accountItem;
              if (contracts && contracts.length > 0) {
                contracts.forEach(contract => {
                  if (contract.totalAmount > 0) {
                    selectedContractdIds.push(getKeyAmountInput(accountItem.id, contract.id));
                    contractdIds.push({ accountId: accountItem.id, contractId: contract.id });
                  }
                });
              }
            }
          });

          setSelectedContractIds(selectedContractdIds);
          setContractIds(contractdIds);
        } else {
          throw new Error(`Status ${response.status}. Status text: ${response.statusText}`);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, [getAccountsUrl, accountId, loading]);

  return { accounts, account, selectedContractIds, contractIds, loading };
};
